import React from "react";
import {
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

const SearchInputField = ({
  searchTerm,
  onSearch,
  currentMatch,
  setCurrentMatch,
  totalMatches,
}) => {
  return (
    <TextField
      fullWidth
      variant="outlined"
      placeholder="Search..."
      value={searchTerm}
      onChange={onSearch}
      sx={{
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            border: "none",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchRoundedIcon
              sx={{
                color: "#94a3b8",
                fontSize: 18,
                filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.1))",
              }}
            />
          </InputAdornment>
        ),
        endAdornment: searchTerm && (
          <InputAdornment position="end">
            <Typography variant="body2" sx={{ mr: 1 }}>
              {currentMatch}/{totalMatches}
            </Typography>
            <IconButton
              size="small"
              onClick={() =>
                setCurrentMatch((prev) => (prev > 1 ? prev - 1 : totalMatches))
              }
              disabled={totalMatches === 0}
            >
              <KeyboardArrowUpIcon fontSize="small" sx={{ color: "#303f9f" }} />
            </IconButton>
            <IconButton
              size="small"
              onClick={() =>
                setCurrentMatch((prev) => (prev < totalMatches ? prev + 1 : 1))
              }
              disabled={totalMatches === 0}
            >
              <KeyboardArrowDownIcon
                fontSize="small"
                sx={{ color: "#303f9f" }}
              />
            </IconButton>
          </InputAdornment>
        ),
        sx: {
          height: 36,
          backgroundColor: "rgba(248, 250, 252, 0.8)",
          borderRadius: "18px",
          backdropFilter: "blur(8px)",
          boxShadow: "inset 0 2px 4px rgba(0,0,0,0.05)",
          transition: "all 0.3s ease",
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          },
          "&:hover": {
            backgroundColor: "rgba(248, 250, 252, 0.9)",
            boxShadow:
              "inset 0 2px 4px rgba(0,0,0,0.05), 0 4px 12px rgba(0,0,0,0.05)",
            transform: "translateY(-1px)",
          },
          "&.Mui-focused": {
            backgroundColor: "#ffffff",
            boxShadow:
              "inset 0 2px 4px rgba(0,0,0,0.05), 0 4px 12px rgba(156, 111, 228, 0.15)",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "1px solid rgba(156, 111, 228, 0.5)",
            },
          },
          "& input": {
            fontSize: "0.8125rem",
            color: "#334155",
            padding: "8px 16px",
            "&::placeholder": {
              color: "#94a3b8",
              opacity: 1,
            },
          },
        },
      }}
    />
  );
};

export default SearchInputField;
